const ACTIONS = {
  ADD_CHILD: "addChild",
  DELETE_CHILD: "deleteChild",
};

export { ACTIONS };
